<template>
  <div class="logo-container">
    <!-- DASHBOARD -->
    <img v-if="type === '1'" src="@assets/img/logo_header.png" :width="width" :height="height" />
    
    <!-- LOGIN -->
    <img v-else src="@assets/logoweb.svg" />
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: '0',
    },
    width: {
      type: String,
      default: '45%',
    },
    height: {
      type: String,
      default: '45%',
    },
  },
};
</script>

<style scoped>
.logo-container {
  margin-top: 1rem;
}
</style>
